export const notification = {
  signup: {
    success: 'Đăng ký thành công',
    fail: 'Đăng ký thất bại',
    emailExisted: 'Email đã tồn tại',
  },
  signin: {
    success: 'Đăng nhập thành công',
    fail: 'Đăng nhập thất bại',
  },
  verifyEmail: {
    success: 'Vui lòng kiểm tra email để lấy lại mật khẩu',
    fail: 'Email không tồn tại',
  },
  resetPassword: {
    success: 'Đặt lại mật khẩu thành công',
    fail: 'Đặt lại mật khẩu thất bại',
  },
  resendCode: {
    success: 'Gửi lại mã thành công',
    fail: 'Gửi lại mã thất bại',
  },
  updateInfor: {
    success: 'Cập nhật thông tin thành công',
    fail: 'Cập nhật thông tin thất bại',
  },
  reaction: {
    success: 'Bạn đã thích bài viết này',
    fail: 'Lỗi khi thích bài viết này',
    unlike: 'Bạn đã bỏ thích bài viết này',
    unlikeFail: 'Lỗi khi bỏ thích bài viết này',
  },
};
